<template>
  <div class="main-not-found">
    <div class="not-found">
      <h1 class="title-not-found">404</h1>
      <h3 class="subtitle-not-found">Page Not Found</h3>
    </div>
  </div>
</template>
<script>
import { useHead } from '@vueuse/head'

export default {
  name: 'NotFound',
  setup() {
    const css = [
      'css/scratch.css',
    ];

    const cssLink = css.map(src => ({
      rel: 'stylesheet',
      href: `${process.env.BASE_URL}${src}`,
    }))

    useHead({
      link: [
        ...cssLink
      ]
    })
  },
  methods: {
  }
}

</script>